
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Category } from "@/types/category";
import { useCategories } from "@/hooks/useCategories";
import { useCategoryGroups } from "@/hooks/useCategoryGroups";

export const useSubscriptionCategories = () => {
  const { categories, isLoading: categoriesLoading } = useCategories();
  const { categoryGroups, isLoading: groupsLoading } = useCategoryGroups();
  
  // Create a category map for easier lookups
  const categoryMap: Record<string, Category> = {};
  categories?.forEach(category => {
    categoryMap[category.id] = category;
  });

  // Create grouped categories structure
  const categoriesGrouped: Record<string, Category[]> = {};
  
  if (categoryGroups && categories) {
    // Initialize with empty arrays for each group
    categoryGroups.forEach(group => {
      categoriesGrouped[group.name] = [];
    });
    
    // Add "Other" category for ungrouped items
    categoriesGrouped["Other"] = [];
    
    // Populate the groups
    categories.forEach(category => {
      if (category.categoryGroupId) {
        const group = categoryGroups.find(g => g.id === category.categoryGroupId);
        if (group) {
          categoriesGrouped[group.name].push(category);
        } else {
          categoriesGrouped["Other"].push(category);
        }
      } else {
        categoriesGrouped["Other"].push(category);
      }
    });
  }
  
  // Get the main category names for rendering
  const mainCategories = Object.keys(categoriesGrouped);
  
  return {
    categories: categoriesGrouped,
    mainCategories,
    isLoading: categoriesLoading || groupsLoading,
    categoryMap
  };
};
